import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as Modal from 'react-modal';
import { Popup } from '../Common/popup';
import evaluations from '../../constants/evaluations';
import { Checkbox } from '../Common/checkbox';
import { CampaignData } from '../../models/Campaign'

export namespace GroupCampaigns{
	export interface Props extends RouteComponentProps<void> {
		campaigns: CampaignData[];
		actions: Actions;
		selectedCampaign: string;
	}

	export interface State{
		createNewModalOpen: boolean;
		editModalOpen: boolean;
	}

	export interface Actions{
		addCampaign: (values: any)=>void;
		selectCampaign: (i: string)=>void;
		editCampaign: (values: any)=>void;
		activateCampaign: (i: string)=>void;
		deleteCampaign: (e: any)=>void;
	}
}

export class GroupCampaigns extends React.Component<GroupCampaigns.Props, GroupCampaigns.State> {
	constructor(props: GroupCampaigns.Props){
		super(props);
		this.state = { createNewModalOpen: false, editModalOpen: false };
	}

	openCreateNewModal(e: any){
		e.preventDefault();
		this.setState({createNewModalOpen: true});
	}

	closeCreateNewModal(e?: any){
		if(e)
			e.preventDefault();
		this.setState({createNewModalOpen: false});
	}

	openEditModal(e: any){
		e.preventDefault();
		this.setState({editModalOpen: true});
	}

	closeEditModal(e?: any){
		if(e)
			e.preventDefault();
		this.setState({editModalOpen: false});
	}

	addCampaign(values: any){
		this.props.actions.addCampaign(values);
		this.closeCreateNewModal();
	}

	editCampaign(values: any){
		this.props.actions.editCampaign(values);
		this.closeEditModal();
	}

	render(){
		const { campaigns, actions, selectedCampaign } = this.props;

		var campaignDOMS = [];
		for(let i = 0; i < this.props.campaigns.length; i++){
			var selected = this.props.selectedCampaign === this.props.campaigns[i]._id ? "am_selected" : "";
			campaignDOMS.push(
				<div className={'row ml-1'}>
					<div 
						onClick={()=>{actions.selectCampaign(campaigns[i]._id)}} 
						tabIndex={i}
						className={selected + ' col-8'}>
						{campaigns[i].name}
					</div>
					<div className={'col-4 nogray'}>
						<div className={'text-center'}>
							<Checkbox noFloat={true} onChange={()=>{actions.activateCampaign(campaigns[i]._id)}} id={campaigns[i]._id} checked={campaigns[i].active}/>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div>
				<p><b>Ryhmän kampanjat</b></p>
				<div className="am_innercontainer row p-2 mr-2">
					<div className={'col-12'}>
						<div className={'row'}>
							<div className={'col-8'}>
								Nimi
							</div>
							<div className={'col-4'}>
								Aktiivinen	
							</div>
						</div>
					</div>
					<div className="am_campaigns am_shortflex">
						{campaignDOMS}
					</div>
					<div className="col-6 p-1">
						<button onClick={this.openEditModal.bind(this)} className="btn am_darkblue-button col-12 m-1"><img src="/images/SettingGear.png" className="am_smallicon" ></img>MUOKKAA VALITTUA KAMPANJAA</button>
					</div>
					<div className="col-6 p-1">
						<button onClick={actions.deleteCampaign} className="btn am_darkblue-button col-12 m-1"><img src="/images/CrossButton.png" className="am_smallicon"></img>POISTA VALITTU KAMPANJA</button>
					</div>
					<button onClick={this.openCreateNewModal.bind(this)} className="btn am_green-button col-12 m-1"><img src="/images/GreenPlusButton.png" className="am_smallicon"></img>LUO UUSI KAMPANJA</button>
				</div>
				<Modal isOpen={this.state.createNewModalOpen} contentLabel="Minimal Modal Example" style={Popup.modalStyle}>
					<Popup.Element element={this.getCreateNewPopupElement()} closeModal={this.closeCreateNewModal.bind(this)}/>
				</Modal>
				<Modal isOpen={this.state.editModalOpen} contentLabel="Minimal Modal Example" style={Popup.modalStyle}>
					<Popup.Element element={this.getEditPopupElement()} closeModal={this.closeEditModal.bind(this)}/>
				</Modal>
			</div>
		);
	}

	getCreateNewPopupElement(){
		let inputs: Popup.Input[] = [];

		inputs.push({name: 'name', type: 'text', required: true, preElement: <h4><b>Kampanjan nimi</b>(Nimeä ei voi muuttaa kesken kampanjan.)</h4>, afterElement: <h4><b>Arvioitavat asiat</b>(Kerran valittuja ei voi poistaa kesken kampanjan.)</h4>});

		let evaluationInputs = [];
		for(let evaluation of evaluations){
				evaluationInputs.push({
					name: evaluation.tag,
					type: 'amountselector',
					width: 6,
					afterElement: <div className="am_evaluationcheck"><img src={evaluation.image}/>{evaluation.name}<br/></div>
				});
		}

		inputs = inputs.concat(evaluationInputs);

		let button: Popup.Button[] = [{text: 'TALLENNA KAMPANJA', image: '/images/GreenPlusButton.png'}]

		let popupelement = ( <div>
			<Popup.Form
				inputs={inputs} 
				buttons={button} 
				accept={this.addCampaign.bind(this)}
			/>
		</div>);

		return popupelement;
	}

	getEditPopupElement(){

		const { selectedCampaign, campaigns } = this.props;
		if(!selectedCampaign) return null;

		const campaignEvals = campaigns.find((o) => o._id === selectedCampaign).evaluations;

		let inputs: Popup.Input[] = [];

		let evaluationInputs = [];
		for(let evaluation of campaignEvals){
			evaluationInputs.push({
				name: evaluation.tag,
				type: 'amountselector',
				width: 6,
				afterElement: (
					<div className="am_evaluationcheck">
						<img src={evaluation.image}/>{evaluation.name}
						<br/>
					</div>),
				disabled: ( evaluation.amount > 0 ),
				value: evaluation.amount
			});
		}

		inputs = inputs.concat(evaluationInputs);

		const button: Popup.Button[] = [{text: 'TALLENNA KAMPANJA', image: '/images/GreenPlusButton.png'}]

		const popupelement = (
			<div>
				<Popup.Form
					inputs={inputs} 
					buttons={button} 
					accept={this.editCampaign.bind(this)}
				/>
			</div>
		);

		return popupelement;
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/GroupSettings/groupcampaigns.tsx